import L from 'leaflet'
import 'leaflet/dist/leaflet.css'

// Route map on tour pages: the places from the day-to-day, numbered by day and joined by a dashed line
export const initTourRoute = () => {
  const el = document.querySelector('.js-tour-route')
  if (!el) return

  let route = []
  try {
    route = JSON.parse(el.dataset.route)
  } catch (e) {
    return
  }
  if (route.length < 2) return

  // Only build the map once it scrolls into view
  const observer = new IntersectionObserver(entries => {
    if (!entries[0].isIntersecting) return
    observer.disconnect()
    buildMap(el, route)
  }, { rootMargin: '300px' })
  observer.observe(el)
}

const buildMap = (el, route) => {
  const touch = window.matchMedia('(pointer: coarse)').matches
  const map = L.map(el, {
    scrollWheelZoom: false,
    // On phones one finger scrolls the page past the map; zoom with the buttons or pinch
    dragging: !touch,
    tap: false,
    zoomSnap: 0.25,
  })

  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
  }).addTo(map)

  const points = route.map(stop => [stop.lat, stop.lng])

  // Soft wide line underneath, dashed line on top
  L.polyline(points, { color: '#3EA986', weight: 8, opacity: 0.18, interactive: false }).addTo(map)
  L.polyline(points, { color: '#0C3B2C', weight: 3, dashArray: '2 8', lineCap: 'round', interactive: false }).addTo(map)

  const last = route.length - 1
  const markers = route.map((stop, index) => {
    const hasDay = stop.day !== null && stop.day !== undefined
    const number = hasDay ? stop.day + 1 : index + 1
    const isEnd = index === 0 || index === last
    const icon = L.divIcon({
      className: '',
      html: `<span class="tour-route__marker${isEnd ? ' is-end' : ''}">${number}</span>`,
      iconSize: [30, 30],
      iconAnchor: [15, 15],
    })
    const label = hasDay ? `Day ${number}` : index === 0 ? 'Start' : index === last ? 'Finish' : `Stop ${number}`

    const marker = L.marker([stop.lat, stop.lng], { icon, title: stop.place, keyboard: false })
      .bindTooltip(`<strong>${stop.place}</strong><span>${label}</span>`, {
        direction: 'top',
        offset: [0, -14],
        className: 'tour-route__tooltip',
      })
      .addTo(map)

    // Clicking a marker opens that day in the day-to-day slider
    if (hasDay) {
      marker.on('click', () => {
        const opener = document.querySelector(`.js-day-open[data-index="${stop.day}"]`)
        if (opener) opener.click()
      })
    }

    return marker
  })

  map.fitBounds(L.latLngBounds(points), { padding: [40, 40] })

  // Clicking a day in the list zooms the map to that day's places
  document.querySelectorAll('.js-tour-route-stop').forEach(button => {
    button.addEventListener('click', () => {
      const dayMarkers = button.dataset.stops.split(',').map(i => markers[parseInt(i, 10)])
      const bounds = L.latLngBounds(dayMarkers.map(marker => marker.getLatLng()))
      map.flyToBounds(bounds, { padding: [60, 60], maxZoom: 11, duration: 0.6 })
      dayMarkers[dayMarkers.length - 1].openTooltip()
      el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    })
  })

  // The overview is hidden while another tab is open; re-measure when it shows again
  new ResizeObserver(() => map.invalidateSize()).observe(el)
}
